var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: "",
        transition: "dialog-bottom-transition",
        "content-class": "dialog-rose-lega",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-rose-lega-card navy darken-2" },
        [
          _c(
            "v-card-title",
            { staticClass: "secondary white--text dialog-rose-lega-title" },
            [
              _c("span", { staticClass: "font-hemi-head" }, [
                _vm._v("ROSE LEGA"),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.dismiss } },
                [
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("close"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("rose-lega", {
            staticClass: "dialog-rose-lega-content",
            attrs: { "show-filters": "", "disable-squadra-menu": "" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }